import { useEffect, useState } from "react";

interface OfficeContext {
  isReady: boolean;
  host: typeof Office.HostType[keyof typeof Office.HostType] | null;
  platform: typeof Office.PlatformType[keyof typeof Office.PlatformType] | null;
  isOutlook: boolean;
  isWord: boolean;
  isPowerPoint: boolean;
}

/**
 * Provides Office.js host/platform info and readiness state.
 */
export function useOfficeContext(): OfficeContext {
  const [context, setContext] = useState<OfficeContext>({
    isReady: false,
    host: null,
    platform: null,
    isOutlook: false,
    isWord: false,
    isPowerPoint: false,
  });

  useEffect(() => {
    Office.onReady((info) => {
      setContext({
        isReady: true,
        host: info.host,
        platform: info.platform,
        isOutlook: info.host === Office.HostType.Outlook,
        isWord: info.host === Office.HostType.Word,
        isPowerPoint: info.host === Office.HostType.PowerPoint,
      });
    });
  }, []);

  return context;
}
